(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-shop-paths"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mt-shop-card')){
  customElements.define('mt-shop-card',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.slides=Array.from(this.querySelectorAll('.mt-home__image'));
      this.index=0;
      this.paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseButton=this.querySelector('[data-pause]');
      this.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>this.advance(Number(button.dataset.direction))));
      this.pauseButton?.addEventListener('click',()=>{
        this.paused=!this.paused;
        this.syncButton();
      });
      this.syncButton();
      this.timer=setInterval(()=>{
        if(!this.paused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement))this.advance(1);
      },5500);
    }
    syncButton(){
      if(!this.pauseButton)return;
      const label=this.paused?this.pauseButton.dataset.play:this.pauseButton.dataset.pauseLabel;
      this.pauseButton.textContent=label;
      this.pauseButton.setAttribute('aria-label',label);
    }
    advance(direction){
      if(this.slides.length<2)return;
      this.slides[this.index].classList.remove('is-current');
      this.index=(this.index+direction+this.slides.length)%this.slides.length;
      this.slides[this.index].classList.add('is-current');
    }
    disconnectedCallback(){clearInterval(this.timer);this.initialized=false}
  });
}

  } catch(e) { console.error(e); }
})();
})();
